// 임베드 앱(iframe) 강제 새로고침 신호 — 모바일 하단 탭바 → EmbedContent(단방향).
// context 를 안 쓰는 이유: EmbedHost → EmbedPage → AppSidebar → MobileTabBar 순서라
// 탭바가 EmbedHost 를 import 하면 순환 참조가 생기고, provider 없이 도는 기존 탭바 테스트가 깨진다.
// 그래서 utils/mobileZoom.js 의 'gw-mobilezoom' 과 같은 CustomEvent 패턴을 쓴다.
export const EMBED_RELOAD_EVENT = 'gw-embed-reload';

// app: 새로고침할 임베드 앱 키('messenger' 등). 반환 = 신호를 실제로 보냈는지 여부.
export function requestEmbedReload(app) {
  if (!app || typeof window === 'undefined') return false;
  try {
    window.dispatchEvent(new CustomEvent(EMBED_RELOAD_EVENT, { detail: { app } }));
    return true;
  } catch (e) {
    return false;
  }
}

// 자기 app 신호만 handler 로 넘긴다. 반환 = 구독 해제 함수(useEffect cleanup 에 그대로 쓰도록 항상 함수).
export function subscribeEmbedReload(app, handler) {
  if (!app || typeof handler !== 'function' || typeof window === 'undefined') return () => {};
  const onReload = (e) => { if (e && e.detail && e.detail.app === app) handler(); };
  window.addEventListener(EMBED_RELOAD_EVENT, onReload);
  return () => { window.removeEventListener(EMBED_RELOAD_EVENT, onReload); };
}

// 임베드 인증 신호 — EmbedHost(복귀·5초 감시·숨은 SSO 성공) → EmbedContent(단방향). 같은 CustomEvent 패턴.
// action: 'check'(로그인 화면인지 확인하고 그럴 때만 재인증) · 'reauth'(재인증) · 'reload'(옛 문서만 다시 불러오기)
export const EMBED_AUTH_EVENT = 'gw-embed-auth';
const EMBED_AUTH_ACTIONS = ['check', 'reauth', 'reload'];

// 반환 = 신호를 실제로 보냈는지 여부(requestEmbedReload 와 같은 계약).
export function requestEmbedAuth(app, action, reason) {
  if (!app || EMBED_AUTH_ACTIONS.indexOf(action) === -1 || typeof window === 'undefined') return false;
  try {
    window.dispatchEvent(new CustomEvent(EMBED_AUTH_EVENT, { detail: { app, action, reason: reason || '' } }));
    return true;
  } catch (e) {
    return false;
  }
}

// 자기 app 신호만 handler(action, reason) 로 넘긴다. 반환 = 구독 해제 함수(항상 함수).
export function subscribeEmbedAuth(app, handler) {
  if (!app || typeof handler !== 'function' || typeof window === 'undefined') return () => {};
  const onAuth = (e) => {
    const d = e && e.detail;
    if (d && d.app === app && EMBED_AUTH_ACTIONS.indexOf(d.action) !== -1) handler(d.action, d.reason || '');
  };
  window.addEventListener(EMBED_AUTH_EVENT, onAuth);
  return () => { window.removeEventListener(EMBED_AUTH_EVENT, onAuth); };
}
